import dogImage from "../Resources/compressjpeg/dog.jpeg";
import catImage from "../Resources/compressjpeg/cat.jpeg";
//import concertImage from "../Resources/compressjpeg/concert.jpeg";
import foodImage from "../Resources/compressjpeg/food.jpeg";
import englandImage from "../Resources/compressjpeg/england.jpeg";
import famImage from "../Resources/compressjpeg/fam.jpeg";
import cafeImage from "../Resources/compressjpeg/cafe.jpeg";
import newsImage from "../Resources/compressjpeg/news.jpeg";
import transitImage from "../Resources/compressjpeg/transit.jpeg";
import cityImage from "../Resources/compressjpeg/city.jpeg";
import warImage from "../Resources/compressjpeg/war.jpeg";
import bostonImage from "../Resources/compressjpeg/boston.jpeg";

const images = {
  dog : dogImage,
  cat : catImage,
  //concert : concertImage,
  food: foodImage,
  england: englandImage,
  fam : famImage,
  cafe: cafeImage,
  news : newsImage,
  transit : transitImage,
  city : cityImage,
  war: warImage,
  boston : bostonImage
};

export default images;
